/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class ThemingConstants {
}
ThemingConstants.GLOBAL_KEY = 'window.sirius.shared.theming';
export var DefaultTheme;
(function (DefaultTheme) {
    DefaultTheme["Dell"] = "dell";
})(DefaultTheme || (DefaultTheme = {}));
export const DefaultThemes = [
    DefaultTheme.Dell.toString()
];
export class DefaultThemeVariantSelectors {
}
DefaultThemeVariantSelectors.USER_PREFERENCES_THEME_VARIANT_SELECTOR = 'USER_PREFERENCES_THEME_VARIANT_SELECTOR';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWluZy5jb25zdGFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL3RoZW1pbmcvdGhlbWluZy5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sZ0JBQWdCOztBQUNGLDJCQUFVLEdBQUcsOEJBQThCLENBQUM7QUFHdkUsTUFBTSxDQUFOLElBQVksWUFFWDtBQUZELFdBQVksWUFBWTtJQUNwQiw2QkFBYSxDQUFBO0FBQ2pCLENBQUMsRUFGVyxZQUFZLEtBQVosWUFBWSxRQUV2QjtBQUVELE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRztJQUN6QixZQUFZLENBQUMsSUFBSSxDQUFDLFFBQVEsRUFBRTtDQUMvQixDQUFDO0FBRUYsTUFBTSxPQUFPLDRCQUE0Qjs7QUFDZCxvRUFBdUMsR0FBRyx5Q0FBeUMsQ0FBQyJ9